import Vue from 'vue';
import Element from 'element-ui';
import '@/assets/theme/index.css';
// import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/es';

Vue.use(Element, { locale, zIndex: 10000 });

// Override default components from Element UI
import ElCard from '@/overrides/ElCard.vue';
import ElDrawer from '@/overrides/ElDrawer.vue';
import ElPopover from '@/overrides/ElPopover.vue';
import ElAlert from '@/overrides/ElAlert.vue';
import ElDialog from '@/overrides/ElDialog.vue';
import ElInput from '@/overrides/ElInput.vue';
import ElFormItem from '@/overrides/ElFormItem.vue';
import ElTabPane from '@/overrides/ElTabPane.vue';

Vue.component('ElCard', ElCard);
Vue.component('ElDrawer', ElDrawer);
Vue.component('ElPopover', ElPopover);
Vue.component('ElAlert', ElAlert);
Vue.component('ElDialog', ElDialog);
Vue.component('ElInput', ElInput);
Vue.component('ElFormItem', ElFormItem);
Vue.component('ElTabPane', ElTabPane);
